(() => {
  const cardSelector = 'product-card.card--collection-v2';
  const regiosBadgeSelector = '[data-created-by-regios-dopp="true"]';

  const syncCardLabels = (card) => {
    const labelContainer = card.querySelector(':scope > .product-label-container');
    const media = card.querySelector(':scope > .card__media');
    if (!labelContainer || !media) return;

    [...media.children].forEach((child) => {
      if (child.matches(regiosBadgeSelector)) labelContainer.appendChild(child);
    });
  };

  const syncAddedNode = (node) => {
    if (!(node instanceof Element)) return;

    const parentCard = node.closest(cardSelector);
    if (parentCard) syncCardLabels(parentCard);
    node.querySelectorAll(cardSelector).forEach(syncCardLabels);
  };

  const observeCards = (root) => {
    if (root.dataset.regiosLabelsObserved === 'true') return;
    root.dataset.regiosLabelsObserved = 'true';

    root.querySelectorAll(cardSelector).forEach(syncCardLabels);

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes') {
          syncAddedNode(mutation.target);
        } else {
          mutation.addedNodes.forEach(syncAddedNode);
        }
      });
    }).observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-created-by-regios-dopp']
    });
  };

  const init = () => {
    document.querySelectorAll('.collection-v2.container, .collection-v2-recommendations, .collection-v2-search').forEach(observeCards);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('search:results-loaded', init);
})();
